import classNames from 'classnames';
import './color-circle.scss';

interface ColorCircleProps {
  accent: string;
  base: string;
  className?: string;
}

export const ColorCircle: React.FC<ColorCircleProps> = ({
  className,
  accent,
  base,
}) => {
  return (
    <div
      className={classNames(className, 'color-circle')}
      style={{
        borderColor: accent,
        backgroundColor: base,
      }}
    />
  );
};
